<template>
  <a-popover title="商品规格" placement="bottom">
    <template slot="content">
      <div style="width: 300px">
        <div v-for="(item, index) in sku_data.sku_fields_list" :key="index">
          <span>{{ item.title }}</span>
          <div class="attr-box">
            <span
              class="attr-item"
              v-for="(attr, a) in item.attrs"
              :key="a"
              @click="onCheckAttr(index, a, attr)"
            >
              <a-button
                v-if="!dianji"
                :type="attr.check ? 'primary' : 'dashed'"
                >{{ attr.title }}</a-button
              >
            </span>
          </div>
        </div>
        <a-button type="primary" @click="onSkuChecked"> 确定 </a-button>
        <a-button  @click="onSkuReset"> 重置 </a-button>
      </div>
    </template>
    <a-input
      style="width: 300px"
      v-model="sku_name"
      :allowClear="true"
      placeholder="请选择商品规格"
      @input="onSkuReset"
    />
  </a-popover>
</template>
<script>
export default {
  name: "SkuPicker",
  data() {
    return {
      dianji: false,
      sku_list: [],
      check_sku_list: [],
    };
  },
  props: {
    sku_data: {
      type: Object,
      required: true,
    },
    sku_id: {
      type: Number | String,
      default: 0,
    },
    sku_name: {
      type: String,
      default: "",
    },
  },
  mounted() {},
  methods: {
    onCheckAttr(index, a, value) {
      this.dianji = true;
      this.sku_data.sku_fields_list[index].attrs.map((value, i) => {
        value.check = false;
      });
      this.sku_data.sku_fields_list[index].attrs[a].check = !value.check;
      this.dianji = false;
      let arr = [];
      if (index == 0) {
        this.sku_data.sku.map((item, i) => {
          if (item.sku[index].attr_id == value.id) {
            this.check_sku_list.push(item);
          }
        });
      }else{
        let arr = [];
        this.check_sku_list.map((item, i) => {
          if (item.sku[index].attr_id == value.id) {
            arr.push(item);
          }
        });
        this.check_sku_list=arr
      }
      console.log(this.check_sku_list);
    },
     
    onSkuChecked() {
      if(this.check_sku_list.length>1){
        this.$message.error('请将规格补充完整')
        return
      }
      let arr = [];
      this.sku_data.sku_fields_list.map((item, i) => {
        item.attrs.map((attr, a) => {
          if (attr.check) {
            arr.push(attr);
          }
        });
      });
      console.log(arr)
      // this.sku_id=this.check_sku_list[0].id
      let name=''
      let p=''
      arr.map((item,i)=>{
        if(i!=0){
          p='/'
        }
        name+=p+item.title
      })
      // this.sku_name=name
      let value={sku_id:this.check_sku_list[0].id,sku_name:name,goods_price:this.check_sku_list[0].price}
      this.$emit('onSkuChecked',value)
      // console.log(this.check_sku_list);
    },
    onSkuReset(){
      this.check_sku_list=[]
      this.dianji=true
      this.sku_data.sku_fields_list.map((item,i)=>{
        item.attrs.map((attr,a)=>{
          attr.check=false
        })
      })
      this.dianji=false
      let value={sku_id:0,sku_name:'',goods_price:0}
      this.$emit('onSkuChecked',value)
    }
  },
};
</script>
<style>
.attr-box {
  display: flex;
  width: 300px;
  align-items: center;
  flex-wrap: wrap;
}
.attr-item {
  display: inline-block;
  padding: 4px 5px;
}
</style>
